/**
 * Selectors that involve more than one slice, and selectors involve borrowed stores
 */
import {RootState} from '~/QuickEcards/store';
import {Guest} from '~/QuickEcards/types/guest';

export const selectIsCreator = ({user, ecard}: RootState) =>
  !!ecard.sender_data.host_id && ecard.sender_data.host_id === user.userId;

export const selectGuests = ({guests}: RootState): Guest[] => guests.guests.page;
